import React, { useEffect, useState } from 'react';
import MapStyle from '../MapStyle';
import LocationMarker from './LocationMarker';
import { GoogleMap } from '@react-google-maps/api';
import type { Supplier } from '../../types/Supplier';

const google = window.google;

interface LocationMapProps {
    onLocationSelect: (location: Supplier) => void;
    locations: Supplier[];
    listHover: Supplier | null;
}

const LocationMap = (props: LocationMapProps) => {
    const { onLocationSelect, locations, listHover } = props;
    const [coordinates, setCoordinates] = useState<google.maps.LatLngLiteral>();

    useEffect(() => {
        if (locations?.length > 0) {
            const location = locations[0];
            setCoordinates({ lat: parseFloat(location.addressLatitude), lng: parseFloat(location.addressLongitude) });
        }
    }, [locations]);

    return (
        <GoogleMap
            center={coordinates}
            zoom={12}
            mapContainerClassName={'ss-old-location-map'}
            options={{
                styles: MapStyle,
                mapTypeControl: true,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT
                },
            }}>
            {
                locations?.length > 0 && locations.map((location) => {
                    return (
                        <LocationMarker
                            key={location.locationId}
                            onLocationSelect={onLocationSelect}
                            location={location}
                            listHover={listHover}
                        />)
                })
            }
        </GoogleMap>
    )
};

export default LocationMap;
